import { createTheme as createMuiTheme } from '@material-ui/core/styles'

export const dark = createMuiTheme({
    palette: {
        primary: { main: '#F9CC04' },
        secondary: { main: '#5D5D5D' },
        background: {
            default: '#202122',
        },
    },

    props: {
        MuiButtonBase: {
            disableRipple: true,
        },
    },

    overrides: {
        MuiCssBaseline: {
            '@global': {
                html: {
                    WebkitFontSmoothing: 'auto',
                    width: '100%',
                    height: '100%',
                    margin: 0,
                    padding: 0,
                },
                body: {
                    height: '100%',
                },

                '*::-webkit-scrollbar': {
                    //hide scrollbar track
                    background: 0,
                    width: '10px',
                    height: '10px',
                },
                '*::-webkit-scrollbar-track': {
                    //hide scrollbar track
                    // width: '20px',
                    background: 0,

                    '&:hover': {
                        background: 'rgba(241, 241, 241, 0.1)',
                    },
                },

                '*::-webkit-scrollbar-thumb': {
                    border: 0,
                    // width: '20px',
                    background: 'rgba(90, 90, 90)',
                },
            },
        },

        MuiButton: {
            label: {
                fontFamily: 'Inv Maison Neue,-apple-system,BlinkMacSystemFont,Open Sans,sans-serif',
                fontSize: '16px',
                letterSpacing: 0,
                color: '#5D5D5D',
            },
        },
        MuiTypography: {
            h1: {
                color: '#F1F1F1',
                fontFamily: 'Inv Maison Neue,-apple-system,BlinkMacSystemFont,Open Sans,sans-serif',
                fontSize: '24px',
                letterSpacing: 0,
                lineHeight: '29px',
                fontWeight: 'normal',
                marginBlockStart: '1em',
                marginBlockEnd: '1em',
                marginInlineStart: '0px',
                marginInlineEnd: '0px',
            },
            h2: {
                color: '#F1F1F1',
                fontFamily: 'Inv Maison Neue,-apple-system,BlinkMacSystemFont,Open Sans,sans-serif',
                fontSize: '16px',
                letterSpacing: 0,
                lineHeight: '16px',
                fontWeight: 'normal',
                marginBlockStart: '1em',
                marginBlockEnd: '1em',
                marginInlineStart: '0px',
                marginInlineEnd: '0px',
            },

            body1: {
                color: '#F1F1F1',
                fontFamily: 'Inv Maison Neue,-apple-system,BlinkMacSystemFont,Open Sans,sans-serif',
                fontSize: '14px',
                letterSpacing: 0,
                lineHeight: '16px',
            },

            body2: {
                color: '#F9CC04',
                fontFamily: 'Inv Maison Neue,-apple-system,BlinkMacSystemFont,Open Sans,sans-serif',
                fontSize: '14px',
                letterSpacing: 0,
                lineHeight: '16px',
            },

            caption: {
                color: '#F1F1F1',
                fontFamily: 'Inv Maison Neue,-apple-system,BlinkMacSystemFont,Open Sans,sans-serif',
                fontSize: '12px',
                letterSpacing: 0,
                lineHeight: '12px',
            },

            colorTextSecondary: {
                color: '#aaa',
                fontSize: '92%',
                margin: '0.1rem 0',
            },
        },

        MuiListItemIcon: {
            root: {
                minWidth: 'unset',
            },
        },
    },
})
